export default "__VITE_ASSET__Dd8kLL0P__ 640w, __VITE_ASSET__JAzE3wsH__ 1024w, __VITE_ASSET__CC3pFf4J__ 1600w";